export const LINK_PAYLATER = `Link {0} Account`;
export const TEXTS = {
    HOLD_ON: "Hold on",
    DELINK_IN_PROGRESS: "We're trying to delink your account",
    KEY_FACT_STATEMENT_TITLE: "Key Fact Statement",
};
